import { ImCheckboxUnchecked } from 'react-icons/im'
import { TiInputChecked } from 'react-icons/ti'
import { Link } from 'react-router-dom'

import { notificationTypeEnumMap } from '../interfaces/notificationTypeEnum'
import { cn } from '../libs/tailwindMerge'
import { Notification } from '../services/appServices'
import { formatDateRelativeTime } from '../utils/formatDateRelativeTime'

interface NotificationItemProps {
  notification: Notification
  markAsSeen: (notification_id: string) => Promise<void>
}

export function NotificationItem({ notification, markAsSeen }: NotificationItemProps) {
  return (
    <div
      className="grid grid-cols-[1fr_2.25rem] border-b last:border-none"
    >
      <Link title="Clique para acessar relatório" to={`/reports/${notification.resource_id}`}>
        <div className="bg-white hover:brightness-95 p-2">
          <div className="flex items-center justify-between">
            <div className="flex space-x-2">
              <div className="flex flex-col mb-2">
                <strong className="leading-tight text-nowrap text-[12px] sm:text-sm">{notification.resource.store.name}</strong>
                <span className="hidden"> - </span>
                <span className="text-nowrap text-[12px] sm:text-sm text-slate-400">{notificationTypeEnumMap[notification.type]}</span>
              </div>
              {notification.notification_recipient && !notification.notification_recipient[0].viewed_at && (
                <div className="relative">
                  <div className="absolute h-[5px] w-[5px] sm:h-2 sm:w-2 rounded-full bg-red-500 right-0 top-[5px] sm:-right-1 sm:top-1 z-[999] animate-ping" />
                  <div className="absolute h-[5px] w-[5px] sm:h-2 sm:w-2 rounded-full bg-red-500 right-0 top-[5px] sm:-right-1 sm:top-1 z-[999]" />
                </div>
              )}
            </div>
            <span className="text-[10px] sm:text-xs text-slate-400">{formatDateRelativeTime(notification.created_at)}</span>
          </div>
          <p className="text-[10px] sm:text-xs w-[15.75rem] sm:w-[30rem]">{notification.description}</p>
        </div>
      </Link>
      <button
        type="button"
        className={cn(
          'flex flex-1 items-center justify-center px-3',
          notification.notification_recipient && notification.notification_recipient[0].viewed_at
            ? 'text-green-900 bg-green-300 sm:bg-green-100'
            : 'text-amber-900 bg-amber-300 sm:bg-amber-100 hover:bg-amber-300',
        )}
        title="Marcar como visto"
        disabled={notification.notification_recipient && notification.notification_recipient[0].viewed_at !== null}
        onClick={() => markAsSeen(notification.id)}
      >
        {notification.notification_recipient && notification.notification_recipient[0].viewed_at
          ? (
            <div>
              <TiInputChecked size={25} />
            </div>
            )
          : (
            <div>
              <ImCheckboxUnchecked size={15} />
            </div>
            )}
      </button>
    </div>
  )
}
